import * as jose from 'jose'

export default {
  decode (token: string) {
    return jose.decodeJwt(token)
  }
}
